import { Component, computed, effect, ElementRef, input, output, Signal, signal, untracked, viewChild, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuotationService } from 'src/app/services/Approver/Quotation/quotation.service';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { ButtonComponent } from "../button/button.component";
import { SpinnerComponent } from "../spinner/spinner.component";
@Component({
  selector: 'camera',
  imports: [
    ButtonComponent,
    FormsModule,
    SpinnerComponent,
  ],
  templateUrl: './camera.component.html',
  styleUrl: './camera.component.scss'
})
export class CameraComponent {
  video      = viewChild<ElementRef>('video');
  canvas     = viewChild<ElementRef>('canvas');
  onClose    = output<void>();
  onCapture  = output<File | null>();
  file_name  = input<string>();
  //UI
  hasCapture: Signal<boolean> = computed(()=>!!this.file_image());
  hasPermission: WritableSignal<boolean> = signal(true);
  video_stream: WritableSignal<MediaStream|null> = signal(null);
  //DATA
  file_image: WritableSignal<File | null> = signal(null);
  image_preview = computed(()=> !!this.file_image() ? URL.createObjectURL(this.file_image()!) : '' );
  video_devices: WritableSignal<InputDevice[]> = signal([]);
  video_source: WritableSignal<string> = signal('');

  constructor(private quotationApi: QuotationService,
              private toast: ToastService
  ) {
    this.checkPermissions();
    effect(() => {
      let source = this.video_source();
      const default_source = this.video_devices()[0];
      this.onCapture.emit(this.file_image());

      untracked(()=> {
        this.openStream(source);
        default_source && this.video_source.set(default_source.deviceId)
      } );
    });
    this.getDevices();
  }

  ngOnDestroy(){
    this.stopStreams();
  }
  getDevices(){
    navigator.mediaDevices.enumerateDevices().then(devices => {
      const videoDevices = devices.filter(device => device.kind === 'videoinput');
      this.video_devices.set(videoDevices);

      if (videoDevices.length) {
        const defaultDevice = videoDevices[0];
        this.video_source.set(defaultDevice.deviceId);
        this.openStream(defaultDevice.deviceId);
        this.hasPermission.set(true);
      }
    });
  }

  openStream(device: string) {
    //STOP OTHER STREAMS
    this.stopStreams();
    navigator.mediaDevices
             .getUserMedia({ video: { deviceId: device }, audio: false })
             .then((stream) => { this.video_stream.set(stream);})
             .catch((e: Error) =>  e.name == 'NotAllowedError' && this.hasPermission.set(false) );
  }

  capture() {
    this.canvas()!.nativeElement.width = 480;
    this.canvas()!.nativeElement.height = 360;
    this.canvas()!.nativeElement
                .getContext('2d')
                .drawImage(this.video()!.nativeElement, 0, 0, 480, 360);
    this.stopStreams();
    const date = new Date();
    this.canvas()!
        .nativeElement
        .toBlob( (blob: any) => this.file_image.set(new File([blob], `${date.getTime()}_${this.file_name()}.png`)),{ type: 'image/png' });
  }
  stopStreams() {
    this.video_stream()?.getTracks().forEach(track => track.stop());
    // this.video?.nativeElement.pause();
  }
  clear() {
    this.file_image.set(null);
    this.openStream(this.video_source());
  }
  checkPermissions(){
    navigator.permissions.query({ name:'camera' })
             .then(permissions => {permissions.onchange = () => this.getDevices() ; });
  }
  reload(){
    location.reload();
  }
}
export interface InputDevice{
  label: string;
  kind: string;
  deviceId: string
}
